// extracted by mini-css-extract-plugin
export default {"root":"ViolatedFilename__root--3hsI0"};